<template>
  <div>
    <el-popover
      placement="right"
      width="130px"
      trigger="hover"
      popper-class="rfqAttachmentsPop"
    >
      <div class="bodyDiv">
        <div v-if="isLook" class="viewdraw" @click="previewCheck('preview')">预览图纸</div>
        <div class="viewdraw"  @click="previewCheck('handleDowload')" >下载图纸</div>
      </div>
      <span class="originalName" slot="reference"><slot></slot></span>
    </el-popover>
  </div>
</template>
<script>
import { getOnlineDrawing } from "@/utils/api/zhenyunOrder";
import { getExtension, downloadFileFun } from "@/utils/common";
import { onlineUrl, url3D } from "@/utils/config";
import zhenyunOrderMinxis from "@/mixins/zhenyunOrder.js";
export default {
  mixins: [zhenyunOrderMinxis],
  props: {
    // 判断文件是否不需要显示预览  默认显示
    isLook: {
      type: Boolean,
      default: true,
    },
    // 预览  是否跳转图纸在线
    toIsAesLink: {
      type: Boolean,
      default: false,
    },
    hashCode: String,
    // 需要根据文件后缀判断是否是3d图纸
    name: String,
    // 预览    需要的加密字符串
    aesRfqId: String,
    // 是否需要接受协议
    isAcceptNda: {
      type: Boolean,
      default: false,
    },
    // 是否符合采购限定要求
    isCanQuote:{
      type: Boolean,
      default: false,
    },
    detailsData:{
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      typeList3D: [
        "slddrw",
        "sldprt",
        "sldasm",
        "prt",
        "eprt",
        "asm",
        "dxf",
        "dwg",
        "x_t",
        "igs",
        "iges",
        "step",
        "stp",
        "stl",
        "ipt",
        "iam",
        "idb",
      ],
      isSettledInfo:null
    };
  },
  methods: {
    // 预览校验
   async previewCheck(fun){
      if(this.detailsData.isAcceptNda==2){
          return this.$message.warning('您的保密协议正在审核中，请耐心等待')
        }
      await this.getOnboarding(this.detailsData.clientId ||20)
      try{
        const {
          authorizationLetter,
          intermediaryServiceAgreement,
          undertakingLetter,
          escrowAccount,
          platformServiceAgreement,
          myBankAuth,
          myBankChannel
        }=this.isSettledInfo
        const zhenyunFlag = [
          authorizationLetter,
          intermediaryServiceAgreement,
          undertakingLetter,
          escrowAccount,
        ].every(item=>item)
        const shukeFlag = [
          undertakingLetter,
          escrowAccount,
          platformServiceAgreement
        ].every(item=>item)
        if(!zhenyunFlag && [20,50].includes(this.detailsData.clientId)){
          // 判断是否入驻？
          this.$emit('accept',0)
          return 
        }
        if([30,70].includes(this.detailsData.clientId) && !shukeFlag){
          // 判断是否入驻？
          this.$emit('accept',0)
          return 
        }
        //判断是否完成网商银行授权
        if(myBankChannel && !myBankAuth){
          this.$emit('changeDetails','promptlyQuot',0)
          return 
        }
        if(this.detailsData.ndaType==2 && this.detailsData.isAcceptNda==0){
          // 判断是否二级保密协议
          this.$emit('accept','nda2')
          return
        }
        if(this.detailsData.ndaType==1 && this.detailsData.isAcceptNda==0){
          // 判断是否一级保密协议
          this.$emit('accept',1)
          return
        }
        //  if(this.isCanQuote!=1){
        //   // 是否符合采购限定要求
        //   this.$emit('accept',2)
        //   return
        // }else{
        //   this[fun]()
        // }
        this[fun]()
      }catch{
        console.error('❌ ~ getOnboarding ~ err:', err)
      }
    },
    // 预览
    async preview() {
      await this.getOnboarding()
      if (this.toIsAesLink && this.aesRfqId) {
        try {
          let formData;
          formData = new FormData();
          formData.append("encryptRfqId", this.aesRfqId);
          formData.append("hashCode", this.hashCode);
          const { data, rspResult } = await getOnlineDrawing().send(formData);
          if (rspResult.bizCode === 200) {
            if (data.type == 1) {
              window.open(
                `${onlineUrl}/saas-drawing/drawing-view?folder=${data.target}&active=${this.hashCode}`
              );
            } else {
              window.open(`${data.url}?active=${this.hashCode}`);
            }
          }
        } catch (err) {
          console.error("❌ ~ getOnlineDrawing ~ err:", err);
        }
      } else if (this.name) {
        const match = getExtension(this.name);
        if (this.typeList3D.includes(match)) {
          window.open(
            `${url3D}/stl/stl.html?stl=${onlineUrl}/mk-rfq-api/drawings/3d-stl/${this.hashCode}`
          );
        } else {
          window.open(
            `${onlineUrl}/mk-rfq-api/common/attach/preview-file/${this.hashCode}`
          );
        }
      } else {
        window.open(
          `${onlineUrl}/mk-rfq-api/common/attach/preview-file/${this.hashCode}`
        );
      }
    },
    // 下载
   async handleDowload() {
        return downloadFileFun(
          `${onlineUrl}/mk-rfq-api/common/attach/download-file/${this.hashCode}`
        );
    },
  },
};
</script>
<style lang="scss" scoped>
.originalName {
  color: #0863ff;
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  cursor: pointer;
  i {
    font-size: 14px;
    margin-right: 5px;
  }
}
.bodyDiv {
  text-align: center;
  .viewdraw {
    height: 32px;
    color: #222222;
    font-size: 14px;
    line-height: 32px;
    cursor: pointer;
  }
  .viewdraw:hover {
    background: #f5f7fa;
    color: #0863ff;
    font-weight: 400;
  }
}
.itemRfqAttach {
  margin-bottom: 8px;
}
</style>
<style lang="scss">
.rfqAttachmentsPop {
  min-width: 104px !important;
  margin-bottom: 8px;
}
</style>